import React, { Dispatch, SetStateAction, useState } from 'react';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { StyledSelectWithInfiniteScroller } from './OptimizePlanForm';
import { IAttributeFilter } from 'types/tpo/Optimization';
import { Level } from './OptimizePlan';

interface IProps {
    selectedBrands: string[];
    setSelectedBrands: Dispatch<SetStateAction<string[]>>;
    selectedSubBrands: string[];
    setSelectedSubBrands: Dispatch<SetStateAction<string[]>>;
    attributeFilters: IAttributeFilter[];
    attributeFiltersLoading: boolean;
    setLevel: Dispatch<SetStateAction<Level>>;
    viewMode?: boolean;
}

const ScopeOfOptimization = ({
    selectedBrands,
    setSelectedBrands,
    selectedSubBrands,
    setSelectedSubBrands,
    attributeFilters,
    attributeFiltersLoading,
    setLevel,
    viewMode = false,
}: IProps) => {
    const [isExpanded, setIsExpanded] = useState<boolean>(true);

    return (
        <div className="px-3 py-2 bg-backgroundGreyAlt rounded-lg mb-3">
            <div
                className="flex justify-between items-center cursor-pointer w-full"
                onClick={() => setIsExpanded(!isExpanded)}
            >
                <span className="font-semibold">Scope of Optimization</span>
                <div>
                    {isExpanded ? (
                        <UpOutlined className="!text-purpleFont" />
                    ) : (
                        <DownOutlined className="!text-purpleFont" />
                    )}
                </div>
            </div>
            {isExpanded && (
                <div>
                    <div className={`flex gap-10 mt-3 ${viewMode ? 'hidden' : ''}`}>
                        <div className="text-sm flex gap-1 items-center">
                            <span>Brand:</span>
                            <StyledSelectWithInfiniteScroller
                                mode="multiple"
                                hasMore={false}
                                showSearch={false}
                                filterOption={false}
                                maxTagCount="responsive"
                                className="dropdown-height !h-8 !w-48"
                                showArrow
                                value={selectedBrands}
                                onChange={(val) => {
                                    setSelectedBrands(val);
                                    setSelectedSubBrands([]);
                                    setLevel('brand');
                                }}
                                options={attributeFilters?.map((filter) => ({
                                    label: filter.brand_name,
                                    value: filter.brand_name,
                                }))}
                                loading={attributeFiltersLoading}
                                placeholder="Select"
                            />
                        </div>
                        <div className="text-sm flex gap-1 items-center">
                            <span>Sub Brand:</span>
                            <StyledSelectWithInfiniteScroller
                                mode="multiple"
                                value={selectedSubBrands}
                                onChange={(val) => {
                                    setSelectedSubBrands(val);
                                    setLevel('sub_brand');
                                }}
                                options={
                                    attributeFilters
                                        ?.filter((filter) => selectedBrands.includes(filter.brand_name))
                                        ?.flatMap((filter) =>
                                            filter.sub_brand_details.map((sub) => ({
                                                label: sub,
                                                value: sub,
                                            })),
                                        ) ?? []
                                }
                                hasMore={false}
                                showSearch={false}
                                filterOption={false}
                                maxTagCount="responsive"
                                className="dropdown-height !h-8 !w-48"
                                showArrow
                                loading={attributeFiltersLoading}
                                disabled={selectedBrands.length === 0}
                                placeholder="Select"
                            />
                        </div>
                    </div>
                    {
                        <div className="text-sm flex gap-1 items-center mt-4">
                            <span>Brands:</span>
                            <span>{selectedBrands.length > 0 ? selectedBrands.join(', ') : '-'}</span>
                        </div>
                    }
                    <div>
                        {
                            <div className="text-sm flex gap-1 items-center mt-2">
                                <span>Sub Brands:</span>
                                <span>{selectedSubBrands.length > 0 ? selectedSubBrands.join(', ') : '-'}</span>
                            </div>
                        }
                    </div>
                </div>
            )}
        </div>
    );
};

export default ScopeOfOptimization;
